import Logger from "@/assets/Helper/Logger";

let CacheFetch = function () {

    let cacheName = "v1-";

    this.init = function () {
        let date = new Date();
        cacheName = cacheName + date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
    }

    this.clear = function () {
        let cacheWhitelist = [cacheName];

        if (typeof window.caches == 'object') {
            window.caches.keys()
                .then(function (cacheNames) {
                    return Promise.all(
                        cacheNames.map(function (cacheName) {
                            if (cacheWhitelist.indexOf(cacheName) === -1) {
                                return window.caches.delete(cacheName).catch(function (error) {
                                        console.log(error)
                                    }
                                );
                            }
                        })
                    );
                })
                .catch(err => {
                    Logger.debug(err);
                })
        }
    };

    this.cacheFirst = function (url) {
        return new Promise((resolve, reject) => {
            if (typeof self.caches == 'object') {
                self.caches.open(cacheName)
                    .then(function (cache) {
                        cache.match(url).then(function (response) {
                            if (response) {
                                Logger.debug(url + ' from cache')

                                handleResponse(url, response)
                                    .then(data => resolve(data))
                                    .catch(() => {
                                        getFromRequest(url, cache, resolve, reject);
                                    })
                            } else {
                                getFromRequest(url, cache, resolve, reject);
                            }
                        });
                    })
                    .catch(err => {
                        Logger.debug(url + ' ' + err);
                        Logger.debug('Unable to open Cache')

                        fetchUrl(url)
                            .then(data => resolve(data))
                            .catch(() => {
                                reject(false)
                            })
                    });
            } else {
                Logger.debug('Cache is not allowed')
                fetchUrl(url)
                    .then(data => resolve(data))
                    .catch(() => {
                        reject(false)
                    })
            }
        });
    };

    let getFromRequest = function (url, cache, resolve, reject) {
        fetch(url).then(response => {
            Logger.debug(url + ' from request')

            cache.put(url, response.clone()).catch((err) => {
                Logger.error(url + ' ' + err)
            });

            handleResponse(url, response)
                .then(data => resolve(data))
                .catch(() => {
                    reject(false)
                })
        })
    };

    let fetchUrl = function (url) {
        return new Promise((resolve, reject) => {
            fetch(url)
                .then(response => {
                    Logger.debug(url + ' from request')

                    handleResponse(url, response)
                        .then(data => resolve(data))
                        .catch(() => {
                            reject(false)
                        })
                })
                .catch(err => {
                    Logger.error(url + ' ' + err);
                    reject(false);
                });
        })
    };

    let handleResponse = function (url, response) {
        return new Promise((resolve, reject) => {
            let responseClone = response.clone()

            response.json().then(json => {
                Logger.debug(url + ' from request')
                resolve(json);
            }).catch(err => {
                responseClone.text().then(response_text => {
                    Logger.error(url + ' ' + err, response_text);
                })
                reject(false);
            });
        });
    };
}

export default new CacheFetch();